import 'react';
import '../types/props.js';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import InlineFlex from 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
var sizeAttributes = {
  default: css(["&{", ";}"], theme('fannypack.Tag.sizes.default')),
  medium: css(["font-size:1em;height:2rem;&{", ";}"], theme('fannypack.Tag.sizes.medium')),
  large: css(["font-size:1.25em;height:2.5rem;&{", ";}"], theme('fannypack.Tag.sizes.large'))
};
var outlinedProperties = css(["&{background-color:unset;border:1px solid ", ";color:", ";fill:", ";}&{", ";}"], palette(), palette(), palette(), theme('fannypack.Tag.outlined'));
var RemoveButton = styled(Button).withConfig({
  displayName: "styled__RemoveButton",
  componentId: "sc-1g01kou-0"
})(["background:none;padding:0 ", "rem;height:100%;min-height:100%;", ";&:focus{box-shadow:inset ", " 0px 0px 0px 2px;}&{", ";}"], space(1), function (props) {
  return props.kind !== 'ghost' && css(["color:", ";"], function (props) {
    return palette(props.palette + "Inverted");
  });
}, function (props) {
  return palette(props.palette === 'default' ? 'primary' : props.palette + "300")(props);
}, theme('fannypack.Tag.RemoveButton.base'));
var TagContent = styled(Box).withConfig({
  displayName: "styled__TagContent",
  componentId: "sc-1g01kou-1"
})(["align-items:center;display:flex;padding:0 ", "em;", ";&{", ";}"], space(2), function (props) {
  return props.isRemovable && css(["padding-right:0rem;"]);
}, theme('fannypack.Tag.TagContent.base'));
var Tag = styled(InlineFlex).withConfig({
  displayName: "styled__Tag",
  componentId: "sc-1g01kou-2"
})(["align-items:center;background-color:", ";border-radius:4px;color:", ";fill:", ";font-size:", "rem;font-weight:", ";height:1.5rem;justify-content:center;&{", ";", ";}&{", ";}"], palette(), function (props) {
  return palette(props.palette + "Inverted");
}, function (props) {
  return palette(props.palette + "Inverted");
}, theme('fannypack.fontSizes.100'), theme('fannypack.fontWeights.semibold'), function (props) {
  return props.styledSize && sizeAttributes[props.styledSize];
}, function (props) {
  return props.kind === 'outlined' && outlinedProperties;
}, theme('fannypack.Tag.base'));
export default Tag;
export { RemoveButton, Tag, TagContent, outlinedProperties, sizeAttributes };